import { ArrowForwardIos, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import BallotIcon from "@mui/icons-material/Ballot";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#3b82f6' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <BallotIcon sx={{ width: "18px", height: "18px", color: "#ef4444" }} />
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Trocar Fluxo
        </div>
      </div>

      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
        {data?.typebotIntegration?.message || 'Trocar para outro fluxo'}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
